import { render, staticRenderFns } from "./LiveBadge.vue?vue&type=template&id=d8263de2&lang=pug&"
import script from "./LiveBadge.vue?vue&type=script&lang=ts&"
export * from "./LiveBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports